import React, { useEffect, useRef } from "react";
import FormFields from "../../../components/Form";
import "react-tabs/style/react-tabs.css";
import SaveButton from "components/SaveButton";
import useAuthUser from "react-auth-kit/hooks/useAuthUser";
import IconButton from "common/IconButton";
import styles from "./paid.module.css";
import { useNavigate } from "react-router-dom";
import Toast from "utils";
import dayjs from "dayjs";

const PaidTicket = ({
  data,
  ticket_id,
  eventDetails,
  ticketDetails,
  setticketDetails_,
  variant_type,
  edit = true,
  onVariantSubmit,
}) => {
  console.log("ticket_id", ticketDetails);

  const handleAddVariant = (e) => {
    e.preventDefault();
    onVariantSubmit(e);
  };

  const handleDuplicateVariant = (e) => {
    e.preventDefault();
    onVariantSubmit(e, true);
  };

  const userDetails = useAuthUser();

  const pathname = window.location.pathname;

  const deriveTicketsSold = () => {
    if (!ticket_id) return 0;
    const initialSold = Number(ticketDetails?.initial_tickets_sold);
    if (!Number.isNaN(initialSold)) {
      return Math.max(0, initialSold);
    }
    const explicitSold = Number(ticketDetails?.tickets_sold);
    if (!Number.isNaN(explicitSold)) {
      return Math.max(0, explicitSold);
    }
    const oldTotal = Number(ticketDetails?.quantity_available) || 0;
    const oldCurrent = Number(ticketDetails?.current_quantity) || 0;
    return Math.max(0, oldTotal - oldCurrent);
  };

  const ticketsSold = deriveTicketsSold();
  const minimumQuantityAllowed = ticket_id ? Math.max(ticketsSold, 0) : 0;

  const handleChange = (label, parseType) => (e) => {
    let value = e?.target ? e?.target?.value : e;

    if (parseType) {
      value = parseType(value);
      if (e?.target?.type === "checkbox") {
        value = parseType(e);
      }
    }

    // Restrict input to two decimal places
    if (typeof value === "number") {
      value = parseFloat(value.toFixed(2)); // Ensure max two decimal places
    }

    if (label === "price") {
      const price = parseFloat(value) || 0;
      const feePercentage = (eventDetails?.event_name?.booking_fee_percentage ?? 10) / 100;
      const booking_fee = parseFloat((price * feePercentage).toFixed(2));
      const customer_pays = parseFloat((price + booking_fee).toFixed(2));
      
      return setticketDetails_((prev) => ({
        ...prev,
        [label]: price,
        booking_fee,
        customer_pays,
        you_receive: price,
      }));
    }

    if (label === "booking_fee") {
      const booking_fee = parseFloat(value) || 0;
      return setticketDetails_((prev) => ({
        ...prev,
        [label]: booking_fee,
        customer_pays: parseFloat((Number(prev?.price || 0) + booking_fee).toFixed(2)),
      }));
    }

    if (label === "quantity_available") {
      const newQuantity = Number(value) || 0;

      if (ticket_id) {
        if (newQuantity < minimumQuantityAllowed) {
          Toast().Error(
            `Total quantity cannot be less than the tickets already sold (${minimumQuantityAllowed}).`
          );
          return setticketDetails_((prev) => ({
            ...prev,
            quantity_available: newQuantity,
          }));
        }

        const newCurrentQuantity = Math.max(0, newQuantity - ticketsSold);
        return setticketDetails_((prev) => ({
          ...prev,
          quantity_available: newQuantity,
          current_quantity: newCurrentQuantity,
        }));
      }

      return setticketDetails_((prev) => ({
        ...prev,
        quantity_available: newQuantity,
      }));
    }

    setticketDetails_((prev) => ({
      ...prev,
      [label]: value,
    }));
  };

  // Skip the initial run so duplicate/prefilled dates survive mount.
  // Only clear dates when the user actively changes the event afterwards.
  const hasMountedRef = useRef(false);
  useEffect(() => {
    if (!hasMountedRef.current) {
      hasMountedRef.current = true;
      return;
    }
    if (eventDetails?.event_name?.value && !edit) {
      setticketDetails_({
        ...ticketDetails,
        on_sale_from: null,
        on_sale_to: null,
      });
    }
  }, [eventDetails?.event_name?.value]);

  useEffect(() => {
    // Sync booking fee when percentage changes (e.g. event selection or load)
    const price = parseFloat(ticketDetails?.price);
    const percentage = eventDetails?.event_name?.booking_fee_percentage;

    if (price && percentage !== undefined) {
      const feePercentage = percentage / 100;
      const calculatedFee = parseFloat((price * feePercentage).toFixed(2));
      const currentFee = parseFloat(ticketDetails?.booking_fee) || 0;

      if (calculatedFee !== currentFee) {
        setticketDetails_((prev) => ({
          ...prev,
          booking_fee: calculatedFee,
          customer_pays: parseFloat((price + calculatedFee).toFixed(2)),
        }));
      }
    }
  }, [eventDetails?.event_name?.booking_fee_percentage, ticketDetails?.price]);

  console.log("innerticketdata", eventDetails);

  const options = [
    {
      value: 1,
      label: "Leanne Graham",
    },
    {
      value: 2,
      label: "Ervin Howell",
    },
  ];
  const startsDate = ticketDetails?.on_sale_from ? dayjs(ticketDetails.on_sale_from).toDate() : null;
  const endsMinDate = startsDate || new Date();
  const maxDate = new Date();
  const endsMaxDate = new Date();
  maxDate.setDate(maxDate.getDate() + 360)
  const FirstFormFields = [
      {
      label: "Description",
      id: "subtitle_description",
      styles: { width: "100% !important" },
      placeholder: "A Brief Description",
      type: "text",
      formGroupStyleOverride: { maxWidth: "100%" },
      value: ticketDetails?.subtitle_description,
      required: true,
      maxLength: 300,
      options,
      onChange: handleChange("subtitle_description"),
    },
    {
      label: "Currency ",
      id: "currency_type",
      placeholder: "Currency Type",
      type: "select",
      value: ticketDetails?.currency_type,
      required: true,
      options: [{ value: "GB", label: "GBP" }],
      onChange: handleChange("currency_type"),
    },
    {
      label: null,
      style: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
      },
      children: [
        {
          label: "Price",
          id: "price",
          // placeholder: "£ 0.00",
          placeholder: " 0.00",
          min: 0,
          max: 1000,
          step: "0.01", 
          type: "number",
          value: ticketDetails?.price,
          required: true,
          pounds: true,
          options,
          onChange: handleChange("price", Number),
        },
        {
          label: "Booking Fee",
          id: "booking_fee",
          placeholder: " 0.00",
          min: 0,
          type: "number",
          value: ticketDetails?.booking_fee,
          // value:  !ticketDetails?.booking_fee ? ticketDetails?.price * 0.1 : ticketDetails?.booking_fee ,

          disabled: userDetails?.role !== "super-admin",
          required: true,
          pounds: true,
          options,
          onChange: handleChange("booking_fee", Number),
        },
        {
          label: "Buyer Pays",
          id: "customer_pays",
          placeholder: "0.00",
          min: 0,
          type: "number",
          value: ticketDetails?.customer_pays,
          // value: Number(ticketDetails?.price) + ticketDetails?.price * 0.1,
          disabled: true,
          required: true,
          pounds: true,
          options,
          onChange: handleChange("customer_pays", Number),
        },
        {
          label: "You Receive",
          id: "you_receive",
          placeholder: "0.00",
          min: 0,

          type: "number",
          value: ticketDetails?.price,
          disabled: true,
          required: true,
          pounds: true,

          options,
          onChange: handleChange("you_receive", Number),
        },
      ],
    },
    {
      label: null,
      style: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
      },
      children: [
        {
          label: "Start Date",
          id: "on_sale_from",
          placeholder: "Pick Date",
          style: { width: "50%" },
          type: "dateTimePicker",
          // maxDate: eventDetails?.event_name?.starts || "",
          formGroupStyleOverride: { flex: 1, marginRight: "20px" },
          selected: ticketDetails?.on_sale_from,
          selectedHours: ticketDetails?.startHours,
          onHoursChange: handleChange("startHours"),
          selectedMinutes: ticketDetails?.startMinutes,
          onMinutesChange: handleChange("startMinutes"),
          required: true,
          onChange: handleChange("on_sale_from"),
          minDate: new Date(),
        },
        {
          label: "End Date",
          id: "on_sale_to",
          placeholder: "Pick Date",
          style: { width: "50%" },
          type: "dateTimePicker",
          formGroupStyleOverride: { flex: 1 },
          selected: ticketDetails?.on_sale_to,
          // maxDate: eventDetails?.event_name?.starts || "",
          required: true,
          onChange: handleChange("on_sale_to"),
          selectedHours: ticketDetails?.endHours,
          onHoursChange: handleChange("endHours"),
          selectedMinutes: ticketDetails?.endMinutes,
          onMinutesChange: handleChange("endMinutes"),
          minDate: endsMinDate, 

        },
      ],
    },
        {
          label: "Quantity Available",
          id: "quantity_available",
          placeholder: "Quantity Available",
          type: "number",
          value: ticketDetails?.quantity_available,
          required: true,
          min: 0,
          // options,
          onChange: handleChange("quantity_available"),
        },
    {
      label: "Order Limits",
      style: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        // width: "100%",
        flex: 1,
      },
      children: [
        {
          label: "Min Tickets Per Order",
          id: "min_tickets_per_order",
          placeholder: "0",
          type: "number",
          width: "50%",
          min: 0,
          // max:1000,
          max: ticketDetails?.max_tickets_per_order || null,
          value: ticketDetails?.min_tickets_per_order,
          formGroupStyleOverride: { flex: 1, marginRight: "20px" },
          required: true,
          options,
          onChange: handleChange("min_tickets_per_order", Number),
        },
        {
          label: "Max Tickets Per Order",
          id: "max_tickets_per_order",
          placeholder: "100",
          type: "number",
          max: ticketDetails?.quantity_available || null,

          min: 0,
          // max:10000,

          value: ticketDetails?.max_tickets_per_order,
          formGroupStyleOverride: { flex: 1 },
          required: true,
          options,
          onChange: handleChange("max_tickets_per_order", Number),
        },
      ],
    },
    {
      label: "Password Protected Ticket",
      parentLabel: "Password Protection",
      id: "is_password_protected",
      name: "is_password_protected",
      type: "checkbox",
      checked: ticketDetails?.is_password_protected ?? false,
      onChange: handleChange("is_password_protected", (e) => e?.target?.checked),
    },
    // Conditionally show password field when checkbox is checked
    ...(ticketDetails?.is_password_protected ? [{
      label: "Ticket Password",
      id: "password",
      placeholder: "Enter password for this ticket",
      type: "text",
      value: ticketDetails?.password || "",
      required: true,
      maxLength: 50,
      onChange: handleChange("password"),
    }] : []),
    {
      label: "Enable Installments",
      parentLabel: "Payment Plans",
      id: "installments_eligible",
      name: "installments_eligible",
      type: "checkbox",
      checked: ticketDetails?.installments_eligible ?? false,
      onChange: handleChange("installments_eligible", (e) => e?.target?.checked),
    },
    ...(ticketDetails?.installments_eligible ? [
      {
        label: "Installment Plans",
        id: "installment_plans",
        placeholder: "Select plans...",
        type: "select",
        isMulti: true,
        value: ticketDetails?.installment_plans || [],
        options: (eventDetails?.event_name?.installment_plans || []).map(plan => ({
          label: plan.replace("installment_", "") + " Months",
          value: plan
        })),
        onChange: handleChange("installment_plans"),
      },
      {
        label: "Minimum Amount for Installments",
        id: "installment_min_amount",
        placeholder: "e.g. 20",
        type: "number",
        min: "0",
        step: "0.01",
        value: ticketDetails?.installment_min_amount,
        required: true,
        onChange: handleChange("installment_min_amount", Number),
      },
    ] : []),
    // {
    //   label: "Disable this ticket type",
    //   parentLabel: "Disable Ticket Type",
    //   id: "disable_ticket_type",
    //   name: "visbility",

    //   placeholder: "100",
    //   type: "checkbox",
    //   checked: ticketDetails?.disable_ticket_type,
    //   // required: true,
    //   options,
    //   onChange: handleChange("disable_ticket_type", (e) => e?.target?.checked),
    // },
    // {
    //   label: "Enable Discount Codes",
    //   parentLabel: "Discount Codes",
    //   id: "enable_discount_codes",
    //   name: "visbility",
    //   placeholder: "100",
    //   type: "checkbox",
    //   checked: ticketDetails?.enable_discount_codes ?? true, // Default to true
    //   // required: true,
    //   options,
    //   onChange: handleChange(
    //     "enable_discount_codes",
    //     // (e) => e?.target?.checked
    //     (e) => {
    //       const isChecked = e?.target?.checked ?? true;
    //       return isChecked;
    //     }
    //   ),
    // },

    // {
    //   label: "Only Accessible via Rep Link",
    //   parentLabel: "Rep Only Ticket",
    //   id: "rep_only_ticket",
    //   name: "visbility",
    //   placeholder: "100",
    //   type: "checkbox",
    //   checked: ticketDetails?.rep_only_ticket,
    //   // required: true,
    //   options,
    //   onChange: handleChange("rep_only_ticket", (e) => e?.target?.checked),
    // },

  
    // {
    //   parentLabel: "Ticket Image",
    //   label:
    //     "Events with images are noticed by more customers, and usually sell more tickets.",
    //   id: "ticket_image",
    //   type: "image",
    //   value: ticketDetails?.ticket_image,
    //   onChange: handleChange("ticket_image"),
    // },
  ];
  const navigate = useNavigate();

  const firstButtonArgs = {
    label: "Cancel",
    id: "cancelTicket",
    type: "button",
    buttonOverrideInlineStyle: { marginRight: "1.6rem" },
    onClick: () => navigate("/ticket"),
  };

  const secondButtonArgs = {
    label: ticket_id ? "Update" : "Create",
    id: "createTicket",
    type: "submit",
    onClick: () => {},
  };


  return (
    <>
      {FirstFormFields?.map((e) => {
        if (e?.children) {
          return (
            <>
              {e?.parentLabel && (
                <label
                  style={{
                    display: "block",
                    width: "100%",
                    textAlign: "left",
                  }}
                >
                  {e?.parentLabel}
                </label>
              )}
              <div style={e?.style}>
                <FormFields Fields={e?.children} />
              </div>
            </>
          );
        }

        return (
          <>
            {e?.parentLabel && (
              <label
                style={{ display: "block", width: "100%", textAlign: "left" }}
              >
                {e?.parentLabel}
              </label>
            )}

            <FormFields Fields={[e]} />
          </>
        );
      })}

      {variant_type === "variant" ? (
        <>
    {!(pathname.startsWith("/ticket/edit-ticket")) && (
        <div className={styles.variantButtonRow}>
          <IconButton
            // label={"Add Another Variant"}
            label={` ${
              pathname === "/ticket/create-ticket"
                ? "Add another Variant"
                : " Add another Variant"
            }`}
            type="submit"
            icon="add"
            buttonFunction={handleAddVariant}
          />
          <IconButton
            label=" Duplicate Variant"
            type="submit"
            icon="add"
            buttonFunction={handleDuplicateVariant}
          />
        </div>
          )}
          <SaveButton
            firstButtonArgs={firstButtonArgs}
            secondButtonArgs={secondButtonArgs} />
        </>
      ) : (
        <SaveButton
          firstButtonArgs={firstButtonArgs}
          secondButtonArgs={secondButtonArgs}
        />
      )}
    </>
  );
};

export default PaidTicket;
